import React, { useEffect, useState } from 'react';
import api from '../../seller-apis/api'
import '../order.css';
import { useAlert } from 'react-alert';
import { useSelector, useDispatch } from "react-redux";
import { Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import { draftedProdInitialCount, pendforapprovProducts, pendingProducts, rejectedProducts } from '../../seller-apis/apidataField';
import AddCatalogue from './NewRequest/AddCatalogue';
import AddManual from './NewRequest/AddManual';
import Rejected from './Rejected';
import ActionRequiredNewPro from './NewRequest/ActionRequiredNewPro';
import DraftedProduct from './DraftedProduct';
import { Actions } from '../../Actions/Actions';


function NewRequest(props) {
  const alert = useAlert()
  const stateData=useSelector(state=>state);
  const dispatch=useDispatch();

  // Records for different orders status
  const [rejectedRec, setrejectedRec] = useState();
  const [pendfappmanual, setpendfappmanual] = useState();
  const [pendfappcatalo, setpendfappcatalo] = useState();
  const [draftedRecord, setDraftedRecords] = useState();
  const [isHighlighted, setIsHighlighted] = useState(false);
  const { path, url } = useRouteMatch()
  
  var filterData = {
    "pageNo": "1",
    "size":1
  }
useEffect(()=>{
  if(stateData.ActionReducer.QCRequestSent.status && stateData.ActionReducer.QCRequestSent.type=='update')
  {
    // Pending products
    api.product.newProductsRetrieveall(pendingProducts({...filterData, "filters":{"status":"pending"}}))
    .then((res) => {
      handleHighlight();
      setpendfappmanual(res.totalRecords)
    })
    .catch(err => console.log(err))

    api.product
    .newProductsRetrieveall(draftedProdInitialCount({...filterData, "filters":{"status":"draft"}}))
    .then((res) => {
      setDraftedRecords(res.totalRecords);
    })
    .catch((err) => console.log(err));
  }
  if(stateData.ActionReducer.QCRequestSent.status && stateData.ActionReducer.QCRequestSent.type=='delete')
  {
    api.product
    .newProductsRetrieveall(draftedProdInitialCount({...filterData, "filters":{"status":"draft"}}))
    .then((res) => {
      setDraftedRecords(res.totalRecords);
    })
    .catch((err) => console.log(err));
  }
},[stateData.ActionReducer.QCRequestSent])
  useEffect(() => {
    

   

    // Pending products
    api.product.newProductsRetrieveall(pendingProducts({...filterData, "filters":{"status":"pending"}}))
    .then((res) => {
      setpendfappmanual(res.totalRecords)
    })
    .catch(err => console.log(err))

  // New request for approval Products
  api.product.vExPrdReqRetrieveAll(pendforapprovProducts(filterData))
    .then((res) => {
      setpendfappcatalo(res.totalRecords)
    })
    .catch(err => {

      console.log(err)
    })

       // Rejected Products
       api.product.vExPrdReqRetrieveAll(rejectedProducts(filterData))
       .then((res) => {
         setrejectedRec(res.totalRecords)
       })
       .catch(err => {
         console.log(err)
       })

       api.product
      .newProductsRetrieveall(draftedProdInitialCount({...filterData, "filters":{"status":"draft"}}))
      .then((res) => {
        setDraftedRecords(res.totalRecords);
      })
      .catch((err) => console.log(err));

  }, [])

  const handleHighlight = () => {
    setIsHighlighted(true);

    // Remove the highlight after 2 seconds
    setTimeout(() => {
      setIsHighlighted(false);
      Actions.QCRequestSend(dispatch,false);
    }, 500);
  };




  return (
    <>
        <div className='filter_options_invent order_nav_cntn d-flex tab mt-3'>

            {/* <div className='ord_table' style={{ width: "100%" }}> */}
              <NavLink exact to={`${url}/drafted`} className={`invent_nav`}><button className='filter_options_btn_invent_new me-2' >Draft {draftedRecord>0&&`(${draftedRecord})`}</button></NavLink>
              <NavLink exact to={`${url}/manual`} className="invent_nav"><button className={`filter_options_btn_invent_new me-2 ${isHighlighted ? 'highlighted' : ''}`}>QC (In progress) {pendfappmanual>0&&`(${pendfappmanual})`}</button></NavLink>
              <NavLink exact to={`${url}/action_req`} className="invent_nav"><button className='filter_options_btn_invent_new me-2' >Action Required</button></NavLink>
              <NavLink exact to={`${url}/rejected`} className="invent_nav"><button className='filter_options_btn_invent_new me-2' >Rejected {rejectedRec>0&&`(${rejectedRec})`}</button></NavLink>
              <NavLink exact to={`${url}/catalogue`} className="invent_nav"><button className='filter_options_btn_invent_new me-2' >Added from Catalogue {pendfappcatalo>0&&`(${pendfappcatalo})`}</button></NavLink>
          {/* </div> */}
        </div>
      <div>
        <Route exact path="/my-inventory/new_product_request">
          <Redirect to={`${path}/catalogue`} />
        </Route>
        <Route path={`${path}/catalogue`} component={AddCatalogue} />
        <Route path={`${path}/manual`} component={AddManual} />
        <Route path={`${path}/rejected`} component={Rejected} />
        <Route path={`${path}/action_req`} component={ActionRequiredNewPro} />
        <Route path={`${path}/drafted`} component={DraftedProduct} />
      </div>
    </>
  )




}


export default NewRequest;